import React, { useState, useEffect } from "react";
import { useLocation, useNavigate, Link } from "react-router-dom"; // Added Link import
import axios from "axios";
import "../App.css";

const API_URL = (process.env.REACT_APP_API_URL || (window.location.hostname === 'localhost' ? 'http://localhost:3001' : '')) + '/api';

const Reservation = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [selectedRijschool, setSelectedRijschool] = useState("");
  const [selectedDate, setSelectedDate] = useState("");
  const [selectedTime, setSelectedTime] = useState("");
  const [message, setMessage] = useState(""); // New state for displaying messages

  useEffect(() => {
    if (location.state) {
      setSelectedRijschool(location.state.selectedRijschool);
      setSelectedDate(location.state.selectedDate);
      setSelectedTime(location.state.selectedTime);
      setMessage(""); // Clear any previous messages
    } else {
      // Replaced alert with message display and immediate navigation
      setMessage("Je moet eerst een reservering maken voordat je doorgaat.");
      // Use setTimeout to allow message to display briefly before navigating
      const timer = setTimeout(() => {
        navigate("/Datepicker");
      }, 2000); // Navigate after 2 seconds
      return () => clearTimeout(timer); // Cleanup the timer
    }
  }, [location.state, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage(""); // Clear previous messages

    try {
      // Added exponential backoff for API calls
      let retries = 0;
      const maxRetries = 5;
      const baseDelay = 1000; // 1 second

      while (retries < maxRetries) {
        try {
          await axios.post(`${API_URL}/book-appointment`, {
            rijschool: selectedRijschool,
            date: selectedDate,
            time: selectedTime,
            name: name,
            email: email,
            phone: phone,
          });
          setMessage("Reservering succesvol!"); // Display success message
          // Use setTimeout to allow message to display briefly before navigating
          const timer = setTimeout(() => {
            navigate("/");
          }, 2000); // Navigate after 2 seconds
          return; // Exit on success
        } catch (error) {
          if (error.response && error.response.status === 429) { // Too Many Requests
            const delay = baseDelay * Math.pow(2, retries);
            console.warn(`Rate limit hit for booking. Retrying in ${delay / 1000}s...`);
            await new Promise(resolve => setTimeout(resolve, delay));
            retries++;
          } else {
            console.error("Fout bij het maken van de reservering:", error);
            if (error.response) {
              const errorMessage = error.response.data.error || "Er is een onbekende fout opgetreden.";
              setMessage(`Fout bij reservering: ${errorMessage}`);
            } else if (error.request) {
              setMessage("Kan de server niet bereiken. Controleer uw netwerkverbinding.");
            } else {
              setMessage(`Er is een fout opgetreden: ${error.message}`);
            }
            break; // Break if it's not a rate limit error
          }
        }
      }
      if (retries === maxRetries) {
        setMessage('Kon reservering niet plaatsen na meerdere pogingen.');
      }
    } catch (error) {
      console.error("Onverwachte fout bij het maken van de reservering:", error);
      setMessage('Er is een onverwachte fout opgetreden bij het plaatsen van de reservering.');
    }
  };

  return (
    <div className="main-content-wrapper fade-in-up" style={{ maxWidth: '900px' }}>
      <div className="top-left-fixed">
        <Link to="/" className="action-button-blue">Home</Link>
      </div>
      
      <h1 className="aharoni-style" style={{ fontSize: '2.5em', marginBottom: '40px' }}>Bevestig je Reservering</h1>

      <div className="admin-grid" style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))', width: '100%' }}>
        <div className="admin-card" style={{ textAlign: 'left', alignItems: 'stretch' }}>
          <h3 style={{ marginBottom: '25px', color: '#007bff' }}>Persoonlijke Gegevens</h3>
          
          <form className="form-container" onSubmit={handleSubmit} style={{ maxWidth: 'none' }}>
            <label className="form-label" htmlFor="name">Naam:</label>
            <input
              type="text"
              id="name"
              className="form-input" 
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
            />
            
            <label className="form-label" htmlFor="email">Email:</label>
            <input
              type="email"
              id="email"
              className="form-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            
            <label className="form-label" htmlFor="phone">Telefoonnummer:</label>
            <input
              type="tel"
              id="phone"
              className="form-input" 
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              required
            />
            
            {message && (
              <p className="error-message" style={{ 
                color: message.includes('succesvol') ? '#28a745' : '#ff4d4d', 
                marginTop: '10px',
                textAlign: 'center',
                fontWeight: 'bold'
              }}>                 
                {message}
              </p>
            )}    
            
            <button type="submit" className="btn" style={{ width: '100%', minWidth: 'auto', marginTop: '20px' }}>
              Definitief Reserveren
            </button>
          </form>
        </div>

        <div className="admin-card">
          <h3 style={{ marginBottom: '25px' }}>Geselecteerde Les</h3>
          <div style={{ padding: '30px', backgroundColor: '#1e1e1e', borderRadius: '15px', border: '1px solid #333', width: '100%', boxSizing: 'border-box' }}>
            <div style={{ marginBottom: '20px', borderBottom: '1px solid #333', paddingBottom: '15px' }}>
               <p style={{ color: '#888', margin: '0 0 5px 0', fontSize: '0.9em', textTransform: 'uppercase' }}>Rijschool</p>
               <p style={{ margin: 0, fontSize: '1.4em', fontWeight: 'bold', color: '#007bff' }}>{selectedRijschool}</p>
            </div>
            <div style={{ marginBottom: '20px', borderBottom: '1px solid #333', paddingBottom: '15px' }}>
               <p style={{ color: '#888', margin: '0 0 5px 0', fontSize: '0.9em', textTransform: 'uppercase' }}>Datum</p>
               <p style={{ margin: 0, fontSize: '1.2em' }}>{selectedDate}</p>
            </div>
            <div>
               <p style={{ color: '#888', margin: '0 0 5px 0', fontSize: '0.9em', textTransform: 'uppercase' }}>Tijdstip</p>
               <p style={{ margin: 0, fontSize: '1.2em', fontWeight: 'bold' }}>{selectedTime}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Reservation;
